import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TextEditorFooter = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1010px) {
    flex-direction: column;
    gap: 4px;
  }
`;

const TextEditorFooterRight = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;

  ${Button.S.Button} {
    font-size: 14px;
    gap: 4px;
  }
`;

const TextEditorFooterText = styled(Typography)`
  margin-left: 8px;
  margin-right: 8px;
`;

const TextEditorHelper = styled.div`
  align-items: center;
  display: flex;
`;

const TextEditorHelperText = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  margin-left: 6px;
`;

const GiftMessageInputs = styled.div`
  height: 100%;
  position: relative;
  width: 100%;

  @media (max-width: 921px) {
    width: 100%;
  }
`;

const GiftMessageArea = styled.div`
  width: 100%;
  word-break: break-word;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  .gift-message-input {
    margin-top: 24px;
  }
`;

const Required = styled.span`
  color: var(--color-error-default);
`;

export {
  GiftMessageArea,
  GiftMessageInputs,
  InputArea,
  Required,
  TextEditorFooter,
  TextEditorFooterRight,
  TextEditorFooterText,
  TextEditorHelper,
  TextEditorHelperText
};
